import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { RequirementService } from '../../services/requirement.service';
import { ResponseObjectAPI } from '../../models/responseObjectAPI';

@Component({
    selector: 'app-asign-lawyer-dialog',
    templateUrl: './asign-lawyer-dialog.component.html',
    styleUrls: ['./asign-lawyer-dialog.component.scss'],
    standalone: false
})
export class AsignLawyerDialogComponent implements OnInit {

  savingLawyer = false;
  form = new FormGroup({
		userSelected: new FormControl('0')
  });

  @Input() users;
  @Input() requirementId;
  @Output() userAsigned = new EventEmitter();

  visibilityId: number;

  constructor(
    public activeModal: NgbActiveModal,
    public requirementService: RequirementService) { }

  ngOnInit() {
  }

  onSubmit() {
    this.savingLawyer = true;
    const body = {
      requirementid: this.requirementId,
      userid: this.form.get('userSelected').value
    };
    this.requirementService.assignLawyer(body).subscribe((resp: ResponseObjectAPI) => {
      this.savingLawyer = false;
      this.userAsigned.emit(this.form.get('userSelected').value);
      this.activeModal.close();
    });
  }

}
